<template>

<div class="edit">

    <div class="edit-head">

        <app-icon icon="close" class="edit-head-back" v-tooltip="'Close modal'" v-on:click.native="onCloseClick" />

        <div class="edit-head-title" v-if="isNew">Add block</div>
        <div class="edit-head-title" v-if="!isNew">Edit block</div>

        <div class="edit-head-actions">

            <app-page-head-action icon="tick" :disabled="!isValid" tooltip="Confirm" v-on:click.native="onConfirmClick" />

        </div>

    </div>

    <div class="edit-body">

		<template v-if="!model.id">

			<app-input-toggle label="Source" v-model="setup" :full-width="true" :options="setupOptions" />
			<app-input-suggest label=" " v-if="setup === 2" v-model="source" :icon="$constants.text.icon" store="texts" placeholder="Search v1 blocks..." />

		</template>

		<template v-if="setup === 1 || source">

			<app-input-type v-model="model.type" :validation="$v.model.type" label="Type" :options="typesFinal" placeholder="Select type" />
			<app-input-text v-model="model.content" :autogrow="true" :label="(isEmbed) ? 'Embed code' : 'Text'" placeholder="Enter text" v-if="hasContent" />
			<app-input-text v-model="model.content" :toolbar="['bold', 'italic', 'underline', 'link']" :autogrow="true" :rich="true" label="Text" placeholder="Enter text" v-if="hasRichContent" />
			<app-input-text v-model="model.url" label="URL" placeholder="Enter url" v-if="hasUrl" />
			<app-input-image v-model="model.image" label="Image" v-if="hasImage" />
			<app-input-suggest v-model="model.group" store="groups" image="image" label="Group" placeholder="Enter group name" v-if="hasGroup" />
			<app-input-text v-model="model.content" label="Text" placeholder="Enter text" v-if="hasText" />
			<app-input-suggest v-model="model.location" store="locations" :show-all="true" image="logo" label="Location" placeholder="Select location" v-if="hasLocation" />

			<app-input-blank label="Preview" v-if="model.type">
				<app-text :item="previewModel" :index="0" :is-first="true" :is-last="true" :is-preview="true" />
			</app-input-blank>

			<app-input-toggle v-model="model.locked" :fullWidth="true" label="Permissions" :options="lockOptions" v-if="isAdmin" />

			<app-input-toggle v-model="model.enabled" :fullWidth="true" label="Visibility" :options="enabledOptions" v-if="isAdmin" />

		</template>

    </div>

</div>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, minValue} from 'vuelidate/lib/validators'

export default {

	mixins: [validationMixin],

    props: ['item', 'section', 'isAdmin'],

    data: function() {

        return {
            enabledOptions: {
                1: 'Shown to users',
                0: 'Hidden from users',
            },
            lockOptions: {
                0: 'Can edit & remove',
                1: 'Can edit only',
                2: 'Locked' 
            },
			setup: 1,
			source: 0,
			setupOptions: {
				1: 'Blank block',
				2: 'Copy v1 block'
			},
            model: {
				id: 0,
				type: 0,
				title: '',
				content: '',
				group: 0,
				location: 0,
				url: '',
				image: '',
                locked: 0,
                enabled: 1
            },
			types: [
				{ value: 2, text: 'Group Name', icon: 'text.type.2' },
				{ value: 11, text: 'Paragraph', icon: 'text.type.11' },
				{ value: 1, text: 'Heading', icon: 'text.type.1' },
				{ value: null },
				{ value: 19, text: '"Lightbulb" bullet', icon: 'text.type.19' },
				{ value: 3, text: '"No" bullet', icon: 'text.type.3' },
				{ value: 7, text: '"Pin" bullet', icon: 'text.type.7' },
				{ value: 5, text: '"Star" bullet', icon: 'text.type.5' },
				{ value: 18, text: '"Stop" bullet', icon: 'text.type.18' },
				{ value: 16, text: '"Thumb" bullet', icon: 'text.type.16' },
				{ value: 17, text: '"Trash" bullet', icon: 'text.type.17' },
				{ value: 4, text: '"Yes" bullet', icon: 'text.type.4' },
				{ value: 14, text: '"Yes" columns', icon: 'text.type.14' },
				{ value: null },
				{ value: 6, text: 'Add Location...', icon: 'text.type.6' },
				{ value: 10, text: 'Add Image...', icon: 'text.type.10' },
				{ value: 12, text: 'Add Embed...', icon: 'text.type.12' },
				{ value: 9, text: 'Link to Group...', icon: 'text.type.9' },
				{ value: null },
				{ value: 13, text: 'Phone', icon: 'text.type.13' },
				{ value: 8, text: 'Website', icon: 'text.type.8' },
				{ value: 21, text: 'Email', icon: 'text.type.21' },
				{ value: 20, text: 'Address', icon: 'text.type.20' },
				{ value: 22, text: 'Hours', icon: 'text.type.22' },
				{ value: 15, text: 'Accepted Items', icon: 'text.type.15' },
			]
        }

    },

	validations: function() {
		
        var validations = {
            model: {
                type: {
                    required,
                    minValue: minValue(1)
                }
            }
        }

        return validations 

	},

    created: function() {

        if (this.$_.isObject(this.item)) {

            this.model = this.$util.clone(this.item)

        }

    },

	watch: {

		source: function(n) {

			if(n) {

				var copy = this.$util.clone(this.$store.getters['texts/find'](this.source))

				this.model.type = copy.type
				this.model.content = copy.content
				this.model.group = copy.group
				this.model.location = copy.location
				this.model.url = copy.url
				this.model.image = copy.image
                this.model.locked = 0
                this.model.enabled = 1


			} else {

				this.model.type = 0
				this.model.title = ''
				this.model.content = ''
				this.model.group = 0
				this.model.location = 0
				this.model.url = ''
				this.model.image = ''
                this.model.locked = 0
                this.model.enabled = 1

			}

		}

	},

	computed: {

		typesFinal: function() {

			if (this.isAdmin) return this.types

			var types = []

			this.$_.each(this.types, function(type) {

				if(this.$_.contains(this.section.types, type.value)) {

					types.push(type)

				}

			}.bind(this))

			return types

		},

		isValid: function() {

			return !this.$v.$invalid

		},

		isNew: function() {

			return this.$route.params[this.param] === 'new' 

		},

		isEmbed: function() {

			return this.model.type === this.$constants.text.type.embed 

		},

		hasContent: function() {

			return this.$_.contains([
				this.$constants.text.type.checklist, 
				this.$constants.text.type.connectedgroups, 
				this.$constants.text.type.title, 
				this.$constants.text.type.embed, 
				this.$constants.text.type.phone, 
				this.$constants.text.type.hours, 
				this.$constants.text.type.link, 
				this.$constants.text.type.address, 
				this.$constants.text.type.email
			], this.model.type)

		},

		hasRichContent: function() {

			return this.$_.contains([
				this.$constants.text.type.tick, 
				this.$constants.text.type.text, 
				this.$constants.text.type.cross, 
				this.$constants.text.type.check, 
				this.$constants.text.type.star, 
				this.$constants.text.type.pin, 
				this.$constants.text.type.trash, 
				this.$constants.text.type.stop, 
				this.$constants.text.type.thumb, 
				this.$constants.text.type.lightbulb
			], this.model.type)

		},

		hasText: function() {

			return this.$_.contains([], this.model.type)

		},

		hasImage: function() {

			return this.$_.contains([this.$constants.text.type.image], this.model.type)

		},

		hasUrl: function() {

			return this.$_.contains([
				this.$constants.text.type.link, 
				this.$constants.text.type.address, 
				this.$constants.text.type.email
			], this.model.type)

		},

		hasGroup: function() {

			return this.$_.contains([this.$constants.text.type.cross, this.$constants.text.type.group], this.model.type)

		},

		hasLocation: function() {

			return this.$_.contains([this.$constants.text.type.location], this.model.type)

		},

		previewModel: function() {

			return {
				id: this.model.id,
				type: parseInt(this.model.type),
				title: this.model.title,
				image: this.model.image,
				url: this.model.url,
				content: this.model.content || ((this.hasContent) ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' : false),
				group: (this.$store.getters['groups'].length && !this.model.group) ? 0 : this.model.group,
				location: (this.$store.getters['locations'].length && !this.model.location) ? 0 : this.model.location
			}

		}

    },

    methods: {

        onConfirmClick: function() {

            this.$emit('confirm', this.model)

        },

        onCloseClick: function() {

            this.$emit('close')

        }

    }

}

</script>

<style scoped>

.edit {
    position: fixed;
    left: 662px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    padding: 10px 40px;
    background-color: #fff;
    z-index: 1000;
    box-shadow: inset 10px 0 15px -3px rgba(0, 0, 0, .1);
}

.edit-head {
	display: flex;
	align-items: center;
}

.edit-head-back {
	font-size: 24px;
	margin-right: 20px;
	flex-shrink: 0;
	color: #0b234e;
	cursor: pointer;
}

.edit-head-title {
    font-size: 24px;
    font-weight: 400;
    flex-grow: 1;
    color: #0b234e;
}

.edit-head-actions {
	display: flex;
	flex-shrink: 0;
	justify-content: flex-end;
}

.edit-body {
    padding: 40px 0px 0px 0px;
}

.notice {
	border-radius: 10px;
	margin-bottom: 20px;
}

</style>